/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, ChartCommonState, IconButtonWrapper, UpIcon, DownIcon } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartLimitNote } from '../ChartLimitNote';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px',
            '& .title': {
                fontSize: 16,
            },
            '& .colWrapper': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 15,
                flexFlow: 'row wrap',
            },
            '& .col': {
                fontSize: '16px',
                fontWeight: 600,
                textAlign: 'center',
                border: '1px solid',
                padding: '15px',
                display: 'flex',
                margin: '0 10px 10px 10px',
                flexFlow: 'column',
                flex: 1,
                '& .value': {
                    fontSize: '36px',
                    padding: '20px 0',
                },
                '& .sub': {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                '& .status': {
                    marginLeft: '10px',
                    display: 'flex',
                    flexFlow: 'row wrap',
                    alignItems: 'center',
                },
            },
            '& .increase': {
                color: 'green',
            },
            '& .decrease': {
                color: 'red',
            },
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            // height: '100vh',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
            '&:hover': {
                '& .scroll': {
                    display: 'flex !important',
                    '& .Mui-disabled': {
                        '& .MuiSvgIcon-root': {
                            color: 'inherit !important'
                        }
                    }
                }
            }
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 10,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            display: 'none',
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            display: 'none',
            position: 'absolute',
            bottom: '50px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);

export enum LastCountEnum {
    PREV_MONTH,
    MONTH,
    FINANCIAL_YEAR,
    PREV_FINANCIAL_YEAR,
}

interface BillingRealisationChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: LastCountEnum;
}

interface ChartState extends ChartCommonState {
    last: LastCountEnum;
    nameData: string[];
    realisationData: number[];
    feesBilledData: number[];
    feesRecordedData: number[];

    currentMonthTotalRealistaion: number;
    currentYearTotalRealistaion: number;
    previousMonthTotalRealistaion: number;
    previousYearTotalRealisation: number;
    symbol: string;
}

export interface BillingRealisationData {
    statistics: Statistics;
}

export interface Statistics {
    fees: Fees;
}

export interface Fees {
    billingRealisation: BillingRealisation;
}

export interface BillingRealisation {
    id: number;
    currentFinancialYear: CurrentFinancialYear;
    currentMonth: CurrentFinancialYear;
    previousFinancialYear: CurrentFinancialYear;
    previousMonth: CurrentFinancialYear;
}

export interface CurrentFinancialYear {
    billingRealisationByStaff: BillingRealisationByStaff[];
    billingRealisationTotal: BillingRealisationTotal;
}

export interface BillingRealisationByStaff {
    id: number;
    feesBilled: number;
    feesRecorded: number;
    name: null | string;
    realisation: number;
}

export interface BillingRealisationTotal {
    id: number;
    totalFeesBilled: number;
    totalFeesRecorded: number;
    totalRealisation: number;
}

export const BillingRealisationChart: React.FC<BillingRealisationChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const { loading, error, data } = useQuery<BillingRealisationData>(ChartData, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CurrencySymbol);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const [state, setState] = useState<ChartState>({
        open: false,
        anchorEl: undefined,
        last: props.selectedOption === undefined ? LastCountEnum.MONTH : props.selectedOption,
        nameData: [],
        realisationData: [],
        feesBilledData: [],
        feesRecordedData: [],

        currentMonthTotalRealistaion: 0,
        currentYearTotalRealistaion: 0,
        previousMonthTotalRealistaion: 0,
        previousYearTotalRealisation: 0,
        symbol: '$',
    });

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (!currencySymbolQuery.loading && !currencySymbolQuery.error && currencySymbolQuery.data) {
            setState((prevState) => {
                const symbol = currencySymbolQuery.data!.options.currencySymbol.symbol;

                return {
                    ...prevState,
                    symbol: symbol,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.data, currencySymbolQuery.error]);

    useEffect(() => {
        if (!loading) {
            setState((prevState) => {
                let nameData: string[] = [];
                let realisationData: number[] = [];
                let feesBilledData: number[] = [];
                let feesRecordedData: number[] = [];

                let currentMonthTotalRealistaion: number = 0;
                let currentYearTotalRealistaion: number = 0;
                let previousMonthTotalRealistaion: number = 0;
                let previousYearTotalRealisation: number = 0;

                let periodString: string = '';
                if (!error && data && data.statistics && data.statistics.fees) {
                    var previousMonth = data.statistics.fees.billingRealisation.previousMonth;
                    var currentFinancialYear = data.statistics.fees.billingRealisation.currentFinancialYear;
                    var currentMonth = data.statistics.fees.billingRealisation.currentMonth;
                    var previousFinancialYear = data.statistics.fees.billingRealisation.previousFinancialYear;

                    currentYearTotalRealistaion = currentFinancialYear.billingRealisationTotal.totalRealisation * 100;
                    currentMonthTotalRealistaion = currentMonth.billingRealisationTotal.totalRealisation * 100;
                    previousMonthTotalRealistaion = previousMonth.billingRealisationTotal.totalRealisation * 100;
                    previousYearTotalRealisation = previousFinancialYear.billingRealisationTotal.totalRealisation * 100;

                    if (state.last === LastCountEnum.MONTH) {
                        periodString = 'Month';
                        nameData = currentMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => (bill.name ? bill.name : ''));
                        realisationData = currentMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.realisation * 100);
                        feesBilledData = currentMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesBilled);
                        feesRecordedData = currentMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesRecorded);
                    } else if (state.last === LastCountEnum.FINANCIAL_YEAR) {
                        periodString = 'Financial Year';
                        nameData = currentFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => (bill.name ? bill.name : ''));
                        realisationData = currentFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.realisation * 100);
                        feesBilledData = currentFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesBilled);
                        feesRecordedData = currentFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesRecorded);
                    } else if (state.last === LastCountEnum.PREV_MONTH) {
                        periodString = 'Previous Month';
                        nameData = previousMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => (bill.name ? bill.name : ''));
                        realisationData = previousMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.realisation * 100);
                        feesBilledData = previousMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesBilled);
                        feesRecordedData = previousMonth.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesRecorded);
                        // currentYearTotalRealistaion = previousFinancialYear.billingRealisationTotal.totalRealisation * 100;
                        // currentMonthTotalRealistaion = previousMonth.billingRealisationTotal.totalRealisation * 100;
                    } else {
                        periodString = 'Previous Financial Year';
                        nameData = previousFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => (bill.name ? bill.name : ''));
                        realisationData = previousFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.realisation * 100);
                        feesBilledData = previousFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesBilled);
                        feesRecordedData = previousFinancialYear.billingRealisationByStaff.map((bill: BillingRealisationByStaff) => bill.feesRecorded);
                        // currentYearTotalRealistaion = previousFinancialYear.billingRealisationTotal.totalRealisation * 100;
                        // currentMonthTotalRealistaion = previousMonth.billingRealisationTotal.totalRealisation * 100;
                    }
                }

                return {
                    ...prevState,
                    periodString,
                    nameData,
                    realisationData,
                    feesBilledData,
                    feesRecordedData,
                    currentMonthTotalRealistaion,
                    currentYearTotalRealistaion,
                    previousMonthTotalRealistaion,
                    previousYearTotalRealisation,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [state.last, loading, error, data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart('IsTimesheetTimeWithBudgetInFinancialYearAggregateChartOpen');
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.last);
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {

            // tslint:disable-next-line: radix
            const option = parseInt((event.target as HTMLInputElement).value);

            return {
                ...prevState,
                last: option
            };
        });
    };

    const handleTotalClick = (isFinancialYear: Boolean) => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (isFinancialYear) {
                if (state.last === LastCountEnum.MONTH || state.last === LastCountEnum.FINANCIAL_YEAR) {
                    searchCriterias.push({ property: 'FinancialYear', operator: 'eq', comparison: 'curr' });
                } else {
                    searchCriterias.push({ property: 'FinancialYear', operator: 'eq', comparison: 'prev' });
                }
            } else {
                if (state.last === LastCountEnum.MONTH || state.last === LastCountEnum.FINANCIAL_YEAR) {
                    searchCriterias.push({ property: 'Month', operator: 'eq', comparison: 'curr' });
                } else {
                    searchCriterias.push({ property: 'Month', operator: 'eq', comparison: 'prev' });
                }
            }

            props.getSelectedItem(searchCriterias, false, 'Billing Realisation', DrillDownType.staffBillingSummary, 'realisation');
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1; 
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };
    
    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.nameData;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        }  else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        } 
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {  
        const labels = state.nameData;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Billing Realisation'));
        // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (loading || currencySymbolQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControllerComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.realisationData) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<MonetizationOnOutlinedIcon />} title="Billing Realisation" />
                <div className="colWrapper">
                    <div className="col">
                        <div className="title">Month to Date</div>
                        <div className={`${classes.totalDiv} value`} onClick={() => handleTotalClick(false)}>
                            <AnimatedNumber value={state.currentMonthTotalRealistaion} format={(amount) => formatNumber(amount, 1)} />%
                            {
                                // tslint:disable-next-line: max-line-length
                                state.currentMonthTotalRealistaion > state.previousMonthTotalRealistaion ? (
                                    <UpIcon className="increase" />
                                ) : state.currentMonthTotalRealistaion < state.previousMonthTotalRealistaion ? (
                                    <DownIcon className="decrease" />
                                ) : (
                                    <div />
                                )
                            }
                        </div>
                        <div className="sub">{`Previous ${formatNumber(state.previousMonthTotalRealistaion, 1)}%`}</div>
                    </div>
                    <div className="col">
                        <div className="title">Year to Date</div>
                        <div className={`${classes.totalDiv} value`} onClick={() => handleTotalClick(true)}>
                            <AnimatedNumber value={state.currentYearTotalRealistaion} format={(amount) => formatNumber(amount, 1)} />%
                            {state.currentYearTotalRealistaion > state.previousYearTotalRealisation ? (
                                <UpIcon className="increase" />
                            ) : state.currentYearTotalRealistaion < state.previousYearTotalRealisation ? (
                                <DownIcon className="decrease" />
                            ) : (
                                <div />
                            )}
                        </div>
                        <div className="sub">{`Previous ${formatNumber(state.previousYearTotalRealisation, 1)}%`}</div>
                    </div>
                </div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const item = state.nameData[_index];

                            const searchCriterias = new Array<SearchCriteria>();
                            // var d = new Date();
                            // var year = d.getFullYear();

                            searchCriterias.push(
                                { property: 'StaffName', operator: 'eq', comparison: item }, //
                            );

                            if (state.last === LastCountEnum.MONTH) {
                                searchCriterias.push({ property: 'Month', operator: 'eq', comparison: '', period: 'curr' });
                            } else if (state.last === LastCountEnum.PREV_MONTH) {
                                searchCriterias.push({ property: 'Month', operator: 'eq', comparison: '', period: 'prev' });
                            } else if (state.last === LastCountEnum.FINANCIAL_YEAR) {
                                searchCriterias.push({ property: 'FinancialYear', operator: 'eq', comparison: '', period: 'curr' });
                            } else if (state.last === LastCountEnum.PREV_FINANCIAL_YEAR) {
                                searchCriterias.push({ property: 'FinancialYear', operator: 'eq', comparison: '', period: 'prev' });
                            }

                            props.getSelectedItem(searchCriterias, false, 'Billing Realisation - ' + item, DrillDownType.staffBillingSummary, 'realisation');
                        }
                    }}
                    data={{
                        labels: getLabels(state.nameData),
                        datasets: [
                            {
                                label: 'Billing Realisation',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary, true),
                                data: state.realisationData,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                stacked: true,
                                suggestedMax: getSuggestedMaxTick(state.realisationData),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.realisationData),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}%`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                min: 0,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue, 1)}%`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {
                                        const {
                                            dataIndex,
                                            //   label,
                                            // formattedValue,
                                            // dataset,
                                        } = context;

                                        return [
                                            `Fees Billed: ${state.symbol}${formatNumber(state.feesBilledData[dataIndex])}`,
                                            `Fees Recorded: ${state.symbol}${formatNumber(state.feesRecordedData[dataIndex])}`,
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.realisationData) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div">
                <RadioGroup name="last" value={state.last} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={LastCountEnum.MONTH} control={<Radio color="primary" />} label="This Month" />
                    <FormControlLabel value={LastCountEnum.PREV_MONTH} control={<Radio color="primary" />} label="Previous Month" />
                    <FormControlLabel value={LastCountEnum.FINANCIAL_YEAR} control={<Radio color="primary" />} label="Financial Year" />
                    <FormControlLabel value={LastCountEnum.PREV_FINANCIAL_YEAR} control={<Radio color="primary" />} label="Previous Financial Year" />
                </RadioGroup>
            </FormControl>
            <ChartNotes notes={['Information collated based on Timekeeper']} actionHint="Drill down to timekeeper details" />
            {!props.showAllRecords && (
                <ChartLimitNote>The top 10 timekeepers are shown</ChartLimitNote>
            )}
        </div>
    );
};

// tslint:disable-next-line:no-any

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

const CurrencySymbol = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

const ChartData = gql`
    query BillingRealisationQuery($entityType: Int, $entityGuid: String, $responsibility: Int, $include: Boolean, $showAllRecords: Boolean) {
        statistics {
            fees {
                billingRealisation(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, include: $include, showAllRecords: $showAllRecords) {
                    currentFinancialYear {
                        billingRealisationByStaff {
                            feesBilled
                            feesRecorded
                            name
                            realisation
                        }
                        billingRealisationTotal {
                            totalFeesBilled
                            totalFeesRecorded
                            totalRealisation
                        }
                    }
                    currentMonth {
                        billingRealisationByStaff {
                            feesBilled
                            feesRecorded
                            name
                            realisation
                        }
                        billingRealisationTotal {
                            totalFeesBilled
                            totalFeesRecorded
                            totalRealisation
                        }
                    }
                    previousFinancialYear {
                        billingRealisationByStaff {
                            feesBilled
                            feesRecorded
                            name
                            realisation
                        }
                        billingRealisationTotal {
                            totalFeesBilled
                            totalFeesRecorded
                            totalRealisation
                        }
                    }
                    previousMonth {
                        billingRealisationByStaff {
                            feesBilled
                            feesRecorded
                            name
                            realisation
                        }
                        billingRealisationTotal {
                            totalFeesBilled
                            totalFeesRecorded
                            totalRealisation
                        }
                    }
                }
            }
        }
    }
`;
